/* eslint-disable operator-linebreak */
/* eslint-disable react/jsx-one-expression-per-line */
import { ErrorMessage, FieldArray, Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { ISecurityQuestionAnswer } from 'src/interfaces';

import { AlertAdapter, LargeButton } from 'pg-ui-library';

import * as yup from 'yup';

import React, { useState } from 'react';
import { CenterText, Input, ModalInput, StyledErrorWrap, Text } from '../styles';

export const MIN_QUESTIONS_ANSWERED = 2;

export const SecurityQuestionAnswerForm: React.FC<{
  onAnswer: Function;
  handleModal: Function;
  questions: ISecurityQuestionAnswer[];
}> = ({ handleModal, questions, onAnswer }) => {
  const [securityQuestionAnswer] = useState<ISecurityQuestionAnswer[]>(questions);

  const { t } = useTranslation();

  const securityQuestionAnswerSchema = yup.object().shape({
    securityQuestionAnswer: yup
      .array()
      .of(
        yup.object().shape({
          questionId: yup.string(),
          answer: yup.string().min(1, t('global.form.min')),
        })
      )
      .required()
      .min(2),
  });

  const onSubmit = async (values: { securityQuestionAnswer: ISecurityQuestionAnswer[] }) => {
    const totalFilled = values.securityQuestionAnswer.filter((sqa: ISecurityQuestionAnswer) => sqa.answer !== '');

    if (totalFilled.length < MIN_QUESTIONS_ANSWERED) {
      AlertAdapter(t('signUp.form.securityQuestions.length'), 'error');
      return;
    }

    onAnswer(totalFilled);
    handleModal(values);
  };

  return (
    <Formik
      initialValues={{
        securityQuestionAnswer,
      }}
      validationSchema={securityQuestionAnswerSchema}
      onSubmit={onSubmit}
    >
      {({ handleChange, isSubmitting }) => (
        <Form style={{ display: 'flex', flexDirection: 'column' }}>
          <CenterText>
            Please answer any <b>two security questions</b> out of available five security questions display on the
            screen. You will need to provide same answers of those security question when you want to Reset your
            password in future.
          </CenterText>

          <FieldArray
            name="securityQuestionAnswer"
            render={() => (
              <>
                {securityQuestionAnswer.map((question, index) => (
                  <div key={question.questionId}>
                    <Text data-cy={`reset-password-security-question-text-${index}`}>{question.question}</Text>
                    <ModalInput>
                      <Input
                        data-cy={`reset-password-security-question-input-${index}`}
                        type="text"
                        name={`securityQuestionAnswer[${index}].answer`}
                        onChange={handleChange}
                      />
                    </ModalInput>

                    <ErrorMessage name={`securityQuestionAnswer[${index}].answer`} component={StyledErrorWrap} />
                  </div>
                ))}
              </>
            )}
          />
          <LargeButton data-cy="reset-password-security-question-submit" type="submit" disabled={isSubmitting}>
            {t('login.resetPassword.button')}
          </LargeButton>
        </Form>
      )}
    </Formik>
  );
};
